import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const organizationipaaddress = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/invoice/{profile}/organization-ipa-address',
    app: 'invoice'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'invoice', model: 'organizationipaaddress' }
    ),
    { }
  )
)()

export { organizationipaaddress, TYPES }
